export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sinks.df6d7172.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};